import type React from 'react'
import type { JSX } from 'react'

import { PageTitleSC } from './PageTitle.styled'

export interface IContainerHeaderProps {
  paddings?: string[]
  children: React.ReactNode
  noTabs?: boolean
}

export const PageTitle = ({
  paddings,
  children,
  noTabs,
}: IContainerHeaderProps): JSX.Element => (
  <PageTitleSC paddings={paddings} noTabs={noTabs}>
    {children}
  </PageTitleSC>
)
